<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box" v-if="result_analysis != ''">
      <!-- excel btn code -->
      <v-row dense>
        <v-col cols="12" sm="6" md="6">
          <v-btn
            rounded
            color="success"
            outlined
            @click="fnExcelReport('my-table-id', 'SubjectResultAnalysis')"
            :loading="loader"
            ><v-icon color="success">mdi-export</v-icon>Export</v-btn
          >
        </v-col>
      </v-row>
      <v-row>
        <div id="my-table-id">
          <v-col cols="12" sm="12" md="12" v-if="sem != 'null'">
            <v-simple-table
              dense
              class="elevation-1"
              fixed-header
              height="500px"
            >
              <thead>
                <tr>
                  <td :colspan="subject_list_header.length + 2">
                    <strong>{{ org_basic_data.school_name }}</strong>
                  </td>
                </tr>
                <tr>
                  <td :colspan="subject_list_header.length + 2">
                    <strong>{{ semester }} Subject Wise Result Analysis</strong>
                  </td>
                </tr>
                <tr>
                  <td :colspan="subject_list_header.length + 2">
                    <strong>{{ section_new }} Section</strong>
                  </td>
                </tr>
                <tr>
                  <td class="">Sr. No.</td>
                  <td class="">Class & Division</td>
                  <td
                    class=""
                    v-for="(header, index) in subject_list_header"
                    :key="index"
                  >
                    {{ header }}
                  </td>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(l, index) in result_analysis" :key="index">
                  <td>{{ index + 1 }}</td>
                  <td>{{ l.standard }} {{ l.division }}</td>
                  <td v-for="(header, index) in l.percentage" :key="index">
                    {{ header }}
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-col>
          <v-col cols="12" sm="12" md="12" v-if="sem == 'null'">
            <v-simple-table
              dense
              class="elevation-1"
              fixed-header
              height="500px"
            >
              <thead>
                <tr>
                  <td :colspan="subject_list_header.length * 2 + 2">
                    <strong>{{ org_basic_data.school_name }}</strong>
                  </td>
                </tr>
                <tr>
                  <td :colspan="subject_list_header.length * 2 + 2">
                    <strong>{{ semester }} Subject Wise Result Analysis</strong>
                  </td>
                </tr>
                <tr>
                  <td :colspan="subject_list_header.length * 2 + 2">
                    <strong>{{ section_new }} Section</strong>
                  </td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td colspan="2"></td>
                  <td
                    colspan="2"
                    v-for="(header, index) in subject_list_header"
                    :key="index"
                  >
                    {{ header }}
                  </td>
                </tr>
                <tr>
                  <td class="">Sr. No.</td>
                  <td class="">Class & Division</td>
                  <th
                    v-for="(header, index) in subject_list_header.length * 2"
                    :key="index"
                  >
                    <span v-if="header % 2 == 0">
                      <center>{{ semester_list[1] }}</center>
                    </span>
                    <span v-else-if="header % 2 == 1">
                      <center>{{ semester_list[0] }}</center>
                    </span>
                  </th>
                </tr>
                <tr v-for="(l, index) in result_analysis" :key="index">
                  <td>{{ index + 1 }}</td>
                  <td>{{ l.standard }} {{ l.division }}</td>
                  <td v-for="(header, index) in l.percentage" :key="index">
                    {{ header }}
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-col>
        </div>
      </v-row>
    </v-card>
    <!-- code for chart  -->
    <!-- <v-card class="box">
      
    </v-card> -->
    <!-- chart code end -->

    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  components: {},
  data() {
    return {
      snackbar_msg: "",
      color: "",
      snackbar: false,
      overlay: false,
      search: null,
      sel_ay_data: null,
      section: null,
      sem: null,
      subject_list_header: [],
      result_analysis: [],
      semester: null,
      org_basic_data: null,
      section_new: null,
      semester_list: null,
      status: null,
      assessment_type: null,
    };
  },
  watch: {
    overlay(val) {
      val = () => {
        this.overlay = false;
      };
    },
  },
  methods: {
    fnExcelReport(id, name) {
      var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
      tab_text =
        tab_text +
        "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
      tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
      tab_text =
        tab_text +
        "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
      tab_text =
        tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
      tab_text = tab_text + "<table border='1px'>";
      var exportTable = $("#" + id).clone();
      exportTable.find("input").each(function (index, elem) {
        $(elem).remove();
      });
      tab_text = tab_text + exportTable.html();
      tab_text = tab_text + "</table></body></html>";
      var fileName =
        name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

      //Save the file
      // var blob = new Blob([tab_text], {
      //   type: "application/vnd.ms-excel;charset=utf-8",
      // });
      // window.saveAs(blob, fileName);
      const blob = new Blob([tab_text], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
       const filename = name+'.xls';

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        // For IE
        window.navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // For modern browsers
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
      }
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    main() {
    
      const formData = {
        ay: this.sel_ay_data,
        section: this.section,
        sem: this.sem,
        status: this.status,
        assessment_type: this.assessment_type
      };
      this.overlay = true;
      axios
        .post("/Examination/subjectResultAnalysis", formData)
        .then((res) => {
          if (res.data.flag == "YES") {
            
            this.result_analysis = res.data.result_analysis;
            this.subject_list_header = res.data.subject_list_header;
            this.semester_list = res.data.semester_list;
            this.semester = res.data.semester;
            this.section_new = res.data.section;
            this.org_basic_data = res.data.org_basic_data;
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong!!!");
            sessionStorage.setItem("error-trace", res.data.error_trace);
            this.overlay = false;
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
  },
  mounted() {
    this.sel_ay_data = localStorage.getItem("setay");
    this.section = localStorage.getItem("setsection");
    this.sem = localStorage.getItem("setsem");
    this.status = localStorage.getItem("setstatus");
    this.assessment_type = localStorage.getItem("setassessmenttype");

    this.main();
  },
};
</script>
<style scoped>
.text-color {
  font-weight: bold;
  color: red;
}
tr,
td,
th {
  border: 1px solid #ccc;
  text-align: center;
}
tr,
tbody {
  border-bottom: 1px solid #ccc;
  border: 1px solid #ccc;
}
td {
  margin: 0.3rem !important;
  padding: 0.4rem !important;
}
@media (min-width: 320px) {
  td,
  th {
    display: table-cell !important;
  }
  td + td,
  th + th {
    width: auto;
  }
}
v-simple-table {
  white-space: nowrap !important;
  text-align: center;
}
.mytable /deep/ thead th {
  background: #0f2027 !important; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ) !important; /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  background-color: #0f2027 !important;
  color: white !important;
  font-weight: bold !important;
  white-space: nowrap !important;
  text-align: center;
}

#my-table-id {
  width: 100%;
}
</style>
